/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _new_notification_body_fr = new IntlMessageFormat(
    [
        { type: 0, value: 'Vous avez ' },
        {
            type: 6,
            value: 'count',
            options: {
                '=1': { value: [{ type: 0, value: '1 notification non lue' }] },
                other: {
                    value: [{ type: 7 }, { type: 0, value: ' notifications non lues' }],
                },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
        { type: 0, value: ' concernant votre société ' },
        { type: 1, value: 'company_name' },
        { type: 0, value: ' sur Go Africa Online. ' },
        { type: 1, value: 'link' },
    ],
    'fr',
);

const _new_notification_body_en = new IntlMessageFormat(
    [
        { type: 0, value: 'You have ' },
        {
            type: 6,
            value: 'count',
            options: {
                '=1': { value: [{ type: 0, value: '1 unread notification' }] },
                other: {
                    value: [{ type: 7 }, { type: 0, value: ' unread notifications' }],
                },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
        { type: 0, value: ' regarding your company ' },
        { type: 1, value: 'company_name' },
        { type: 0, value: ' on Go Africa Online. ' },
        { type: 1, value: 'link' },
    ],
    'en',
);

export function new_notification_body(
    args: { count: number; company_name: string; link: string },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _new_notification_body_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _new_notification_body_en.format(args) as unknown as string;
    }

    return _new_notification_body_fr.format(args) as unknown as string;
}

const _new_inbox_message_body_fr = new IntlMessageFormat(
    [
        { type: 0, value: 'Bonjour,\nvous avez ' },
        {
            type: 6,
            value: 'count',
            options: {
                '=1': { value: [{ type: 0, value: '1 nouveau message' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' nouveaux messages' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
        { type: 0, value: ' sur Go Africa.\nCliquez-ici pour ' },
        {
            type: 6,
            value: 'count',
            options: {
                '=1': { value: [{ type: 0, value: 'le' }] },
                other: { value: [{ type: 0, value: 'les' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
        { type: 0, value: ' consulter :\n' },
        { type: 1, value: 'link' },
        { type: 0, value: '\nNe ratez aucune opportunité !' },
    ],
    'fr',
);

const _new_inbox_message_body_en = new IntlMessageFormat(
    [
        { type: 0, value: 'Hello,\nyou have ' },
        {
            type: 6,
            value: 'count',
            options: {
                '=1': { value: [{ type: 0, value: '1 new message' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' new messages' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
        { type: 0, value: ' on Go Africa.\nClick here to check ' },
        {
            type: 6,
            value: 'count',
            options: {
                '=1': { value: [{ type: 0, value: 'it' }] },
                other: { value: [{ type: 0, value: 'them' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
        { type: 0, value: ' out:\n' },
        { type: 1, value: 'link' },
        { type: 0, value: "\nDon't miss any opportunity!" },
    ],
    'en',
);

export function new_inbox_message_body(
    args: { count: number; link: string },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _new_inbox_message_body_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _new_inbox_message_body_en.format(args) as unknown as string;
    }

    return _new_inbox_message_body_fr.format(args) as unknown as string;
}

const _new_multi_quote_body_fr = new IntlMessageFormat(
    [
        { type: 0, value: 'Bonjour,\nVous avez ' },
        {
            type: 6,
            value: 'count',
            options: {
                '=1': { value: [{ type: 0, value: '1 nouvelle demande de devis' }] },
                other: {
                    value: [
                        { type: 7 },
                        { type: 0, value: ' nouvelles demandes de devis' },
                    ],
                },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
        {
            type: 0,
            value: ' sur Go Africa.\nConsultez votre mail pour en prendre connaissance.\nNe ratez aucune opportunité !',
        },
    ],
    'fr',
);

const _new_multi_quote_body_en = new IntlMessageFormat(
    [
        { type: 0, value: 'Hello,\nYou have ' },
        {
            type: 6,
            value: 'count',
            options: {
                '=1': { value: [{ type: 0, value: '1 new quote request' }] },
                other: {
                    value: [{ type: 7 }, { type: 0, value: ' new quote requests' }],
                },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
        {
            type: 0,
            value: " on Go Africa.\nCheck your email to learn more.\nDon't miss any opportunity!",
        },
    ],
    'en',
);

export function new_multi_quote_body(args: { count: number }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _new_multi_quote_body_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _new_multi_quote_body_en.format(args) as unknown as string;
    }

    return _new_multi_quote_body_fr.format(args) as unknown as string;
}
